import cx from 'classnames';
import React from 'react';

interface ContainerProps {
  children?: React.ReactNode;
  className?: string;
}

export const Container: React.FC<ContainerProps> = ({children, className = ''}) => (
  <div
    id="create-container"
    className={cx({
      'create-container': true,
      [className]: !!className,
    })}
  >
    {children}
  </div>
);
